import { AfterViewInit, Component } from '@angular/core';

import { BasePage } from '../../base.page';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './unauthorized.page.html',
    styleUrls: ['./unauthorized.page.scss'],
})
export class UnauthorizedPage extends BasePage implements AfterViewInit {
    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
